import React from "react";

const TextElipse = (props) => {
  return (
    <span>
      {props.children.substring(0, props.length)}
      {props.children.length > props.length && "..."}
    </span>
  );
};

export default TextElipse;
